import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'voltage',
  standalone: false,
})
export class VoltagePipe implements PipeTransform {
  transform(voltageKV?: number): number {
    const voltageV = voltageKV ? voltageKV / 1000 : null
    return voltageV
  }
}
